export class Frequency{
    constructor(
        public id: number,
        public name: string
    ){}
}